// SubAIVA Type Definitions

export interface Env {
  // DurableObjectNamespace is typed to SubAIVA for RPC method access
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  SUBAIVA: DurableObjectNamespace<any>;
  MEMORY_VECTORS?: VectorizeIndex;  // Optional: unavailable in local dev
  AI?: Ai;                          // Optional: unavailable in local dev
  ENTITLEMENTS?: KVNamespace;       // Optional: unavailable in local dev
  API_TOKEN: string;
  ADMIN_TOKEN?: string;             // Admin dashboard auth
  STRIPE_API_KEY?: string;          // Stripe secret key
  STRIPE_WEBHOOK_SECRET?: string;   // Stripe webhook signing secret
  RESEND_API_KEY?: string;          // Resend email API key
  DEFAULT_MODEL: string;
  EMBEDDING_MODEL: string;
  ENVIRONMENT: string;
}

// Tier capabilities — what each subscription level unlocks
export interface TierConfig {
  tier: number;
  name: string;
  maxMemories: number;
  maxConversationHistory: number;
  hasVoice: boolean;
  hasBrowser: boolean;
  hasIDE: boolean;
  hasMCP: boolean;
  model: string;
  memoryDecayDays: number; // 0 = infinite retention
}

export const TIER_CONFIGS: Record<number, TierConfig> = {
  1: {
    tier: 1,
    name: "Starter",
    maxMemories: 500,
    maxConversationHistory: 50,
    hasVoice: false,
    hasBrowser: false,
    hasIDE: false,
    hasMCP: false,
    model: "@cf/meta/llama-3.1-8b-instruct",
    memoryDecayDays: 30,
  },
  2: {
    tier: 2,
    name: "Professional",
    maxMemories: 5000,
    maxConversationHistory: 200,
    hasVoice: false,
    hasBrowser: false,
    hasIDE: false,
    hasMCP: false,
    model: "@cf/meta/llama-3.3-70b-instruct-fp8-fast",
    memoryDecayDays: 90,
  },
  3: {
    tier: 3,
    name: "Enterprise",
    maxMemories: 50000,
    maxConversationHistory: 1000,
    hasVoice: true,
    hasBrowser: false,
    hasIDE: false,
    hasMCP: false,
    model: "@cf/meta/llama-3.3-70b-instruct-fp8-fast",
    memoryDecayDays: 0, // infinite
  },
};

export interface ChatMessage {
  role: "user" | "assistant" | "system";
  content: string;
  timestamp?: number;
}

export interface Memory {
  id: string;
  content: string;
  category: string;
  importance: number;
  createdAt: number;
  lastAccessed: number;
  accessCount: number;
}

export interface SubAIVAState {
  customerId: string;
  tier: number;
  systemPrompt: string;
  createdAt: number;
  lastActive: number;
  totalMessages: number;
}

// WebSocket message types
export interface WSMessage {
  type: "chat" | "memory_store" | "memory_search" | "status" | "config";
  payload: Record<string, unknown>;
  requestId?: string;
}

export interface WSResponse {
  type: "chat_response" | "memory_result" | "status" | "error" | "stream_chunk" | "stream_end";
  payload: Record<string, unknown>;
  requestId?: string;
}
